import React, { useState } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthLayout from '../components/AuthLayout';

const Register = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const result = await register(values.firstName, values.lastName, values.email, values.password);
      if (result.success) {
        setSuccess('Registration successful! Redirecting to login...');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        setError(result.message || 'Registration failed');
      }
    } catch {
      setError('An error occurred during registration');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Join the team."
      subtitle={<>Create your <strong>Festivals Portal</strong> account</>}
      footer={
        <>
          Already have an account? <Link to="/login" className="auth__link">Sign in</Link>
        </>
      }
    >

      {error && <Alert message={error} type="error" showIcon role="alert" />}
      {success && <Alert message={success} type="success" showIcon role="status" />}

      <Form name="register" onFinish={onFinish} layout="vertical" requiredMark={false}>
        <div className="auth__row">
          <Form.Item name="firstName" label="First name" rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder="John" autoComplete="given-name" autoFocus />
          </Form.Item>
          <Form.Item name="lastName" label="Last name" rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder="Doe" autoComplete="family-name" />
          </Form.Item>
        </div>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Enter your email' },
            { type: 'email', message: 'Enter a valid email address' },
          ]}
        >
          <Input type="email" placeholder="you@festivals.mt" autoComplete="email" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: 'Enter a password' },
            { min: 6, message: 'Use at least 6 characters' },
          ]}
        >
          <Input.Password placeholder="Create a password" autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm password"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Confirm your password' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) return Promise.resolve();
                return Promise.reject(new Error('Passwords do not match'));
              },
            }),
          ]}
          style={{ marginBottom: 28 }}
        >
          <Input.Password placeholder="Repeat your password" autoComplete="new-password" />
        </Form.Item>

        <Button type="primary" htmlType="submit" loading={loading} className="auth__submit">
          Create account
        </Button>
      </Form>
    </AuthLayout>
  );
};

export default Register;